import React from 'react';
import imageAction from './img/image.png';
import s from './index.module.scss';

export default function Alert() {

	function refreshPage() {
		window.location.reload(false);
	}

	return (
		<div className={s.alert_overlay} id="alert">
			<div className={s.spinner_wrapper}>
				<div className={s.spinner}>
					<svg width='68' height='68'>
						<circle
							stroke='#DADADA'
							strokeWidth='3'
							cx='34'
							cy='34'
							r='32'
							fill='transparent'
							strokeLinecap='round'
							strokeDasharray='140'
							strokeDashoffset='0'
						></circle>
					</svg>
				</div>
			</div>
			<div className={s.alert_message} id="alertMessage">
				<div className={s.alert_message_title}>
					We are searching
					<br />
					for a problem
				</div>
				<div className={s.alert_message_description}>Please check your internet connection and reload the page</div>
				<img className={s.image_action} src={imageAction} alt='imageAction' />
				<div className={s.alert_message_button} onClick={refreshPage}>Reload</div>
			</div>
		</div>
	);
}
